var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-menu-component" }, [
    _c(
      "div",
      { staticClass: "room-setting-menu-wrapper" },
      _vm._l(_vm.menuList, function (menu) {
        return _c(
          "button",
          {
            key: menu.type,
            staticClass: "room-setting-menu-item",
            class: [{ selected: _vm.isSelected == menu.type }, menu.type],
            attrs: {
              name: menu.type,
              title: menu.name,
              "aria-label": menu.name,
              tabindex: "3",
            },
            on: {
              click: function ($event) {
                return _vm.onClickMenu($event)
              },
            },
          },
          [
            _c("span", { staticClass: "room-setting-menu-icon" }),
            _c("span", { staticClass: "room-setting-menu-tx" }, [
              _vm._v(_vm._s(menu.name)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }